import { B2BMeResponse, MeResponse, UserRegistrationResponse } from 'signature-public-api-sdk';
import { AppThunk } from '€slices/types';
import api from '€api/client';
import { LoginProps } from './auth-types';
import { actions } from './auth-slice';
import { callApi } from '€slices/network';
import { resetUserData } from '€slices/data/data-thunks';
import { user } from '€slices/user/user-selectors';
import { actions as pwaActions } from '€slices/pwa';

export const login =
    ({ username, password }: LoginProps): AppThunk =>
    async (dispatch, getState) => {
        dispatch(actions.requestLogin());

        const [error, data] = await dispatch(callApi(api.Auth.login(username, password)));

        if (error) {
            dispatch(actions.receiveLoginFailure(error.error.message));

            throw error.error;
        }

        const currentUser = user(getState());
        if (!currentUser || (currentUser && data.user.name !== currentUser.name)) {
            dispatch(resetUserData());
        }

        dispatch(actions.receiveLoginSuccess(data));
        dispatch(pwaActions.setVisibility({ isVisible: true }));
    };

export const validateAuthCookie = (): AppThunk => async dispatch => {
    dispatch(actions.requestValidateAuthCookie());

    const [error, data] = await dispatch(callApi<B2BMeResponse>(api.BrokerPortal.Users.me()));

    if (error) {
        dispatch(actions.receiveValidateAuthCookieFailure(error.error.message));
    } else {
        dispatch(actions.receiveValidateAuthCookieSuccess(data));
    }
};

export const logout = (): AppThunk => async dispatch => {
    await api.Auth.logout();
    dispatch(actions.logout());
};
